// @helpers
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../constants/actionTypes');

const getFiocFormStatusInProgress = () => ({
    type: actionTypes.GET_FIOC_FORM_STATUS_IN_PROGRESS,
});

const getFiocFormStatusSuccess = response => ({
    type: actionTypes.GET_FIOC_FORM_STATUS_SUCCESS,
    payload: {
        response,
    }
});

const getFiocFormStatusError = error => ({
    type: actionTypes.GET_FIOC_FORM_STATUS_ERROR,
    error,
});

const getFiocFormStatusReset = () => ({
    type: actionTypes.GET_FIOC_FORM_STATUS_RESET,
});

const getFiocFormStatus = () => dispatch => {
    dispatch(getFiocFormStatusInProgress());
    return APIGet({
        dispatch,
        endpoint: 'fiocFormStatus',
    })
    .then(response => {
        dispatch(getFiocFormStatusSuccess(response));
        return response;
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(getFiocFormStatusError(response.body));
        }
        else {
            throw response;
        }
    });
};

module.exports = {
    getFiocFormStatus,
    getFiocFormStatusReset,
};
